/**
 * @generated SignedSource<<9019bded6d38bec4bfb5cae4c278f078>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClassExitSlipsFilterInput = {
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  includeCanceled?: boolean | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type ExitSlipClassExitSlipDueOnByClassesQuery$variables = {
  filter?: ClassExitSlipsFilterInput | null | undefined;
};
export type ExitSlipClassExitSlipDueOnByClassesQuery$data = {
  readonly classExitSlips: ReadonlyArray<{
    readonly canceledOn: any | null | undefined;
    readonly curriculumLesson: {
      readonly id: string;
      readonly number: string | null | undefined;
    } | null | undefined;
    readonly dueOn: any;
  }>;
};
export type ExitSlipClassExitSlipDueOnByClassesQuery = {
  response: ExitSlipClassExitSlipDueOnByClassesQuery$data;
  variables: ExitSlipClassExitSlipDueOnByClassesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueOn",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canceledOn",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "CurriculumLessonNode",
  "kind": "LinkedField",
  "name": "curriculumLesson",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipClassExitSlipDueOnByClassesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipClassExitSlipDueOnByClassesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassExitSlipNode",
        "kind": "LinkedField",
        "name": "classExitSlips",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f6c2c287b17a5f75a2d66fbdbd047474",
    "id": null,
    "metadata": {},
    "name": "ExitSlipClassExitSlipDueOnByClassesQuery",
    "operationKind": "query",
    "text": "query ExitSlipClassExitSlipDueOnByClassesQuery(\n  $filter: ClassExitSlipsFilterInput\n) {\n  classExitSlips(filter: $filter) {\n    dueOn\n    canceledOn\n    curriculumLesson {\n      id\n      number\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "34e1581c54bf2ca8f9ef91d263e1799c";

export default node;
